/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppMyTasksRouteImport } from './routes/_app/my-tasks'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectKeyRouteImport } from './routes/_app/projects/$projectKey'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsConnectionsRouteImport } from './routes/_app/settings/connections'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsPeopleRouteImport } from './routes/_app/settings/people'
import { Route as AppSettingsSlackRouteImport } from './routes/_app/settings/slack'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppMyTasksRoute = AppMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectKeyRoute = AppProjectsProjectKeyRouteImport.update({
  id: '/projects/$projectKey',
  path: '/projects/$projectKey',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsConnectionsRoute = AppSettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsPeopleRoute = AppSettingsPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSlackRoute = AppSettingsSlackRouteImport.update({
  id: '/slack',
  path: '/slack',
  getParentRoute: () => AppSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/inbox': typeof AppInboxRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/projects/$projectKey': typeof AppProjectsProjectKeyRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/people': typeof AppSettingsPeopleRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AppDashboardRoute
  '/inbox': typeof AppInboxRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/': typeof AppIndexRoute
  '/projects/$projectKey': typeof AppProjectsProjectKeyRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/people': typeof AppSettingsPeopleRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/projects': typeof AppProjectsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/my-tasks': typeof AppMyTasksRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/oauth/consent': typeof OauthConsentRoute
  '/_app/': typeof AppIndexRoute
  '/_app/projects/$projectKey': typeof AppProjectsProjectKeyRoute
  '/_app/settings/connections': typeof AppSettingsConnectionsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/people': typeof AppSettingsPeopleRoute
  '/_app/settings/slack': typeof AppSettingsSlackRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/login'
    | '/dashboard'
    | '/inbox'
    | '/my-tasks'
    | '/settings'
    | '/oauth/consent'
    | '/projects/$projectKey'
    | '/settings/connections'
    | '/settings/notifications'
    | '/settings/people'
    | '/settings/slack'
    | '/projects/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/join'
    | '/login'
    | '/dashboard'
    | '/inbox'
    | '/my-tasks'
    | '/oauth/consent'
    | '/'
    | '/projects/$projectKey'
    | '/settings/connections'
    | '/settings/notifications'
    | '/settings/people'
    | '/settings/slack'
    | '/projects'
    | '/settings'
  id:
    | '__root__'
    | '/_app'
    | '/join'
    | '/login'
    | '/_app/dashboard'
    | '/_app/inbox'
    | '/_app/my-tasks'
    | '/_app/settings'
    | '/oauth/consent'
    | '/_app/'
    | '/_app/projects/$projectKey'
    | '/_app/settings/connections'
    | '/_app/settings/notifications'
    | '/_app/settings/people'
    | '/_app/settings/slack'
    | '/_app/projects/'
    | '/_app/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-tasks': {
      id: '/_app/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof AppMyTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectKey': {
      id: '/_app/projects/$projectKey'
      path: '/projects/$projectKey'
      fullPath: '/projects/$projectKey'
      preLoaderRoute: typeof AppProjectsProjectKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/connections': {
      id: '/_app/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AppSettingsConnectionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/people': {
      id: '/_app/settings/people'
      path: '/people'
      fullPath: '/settings/people'
      preLoaderRoute: typeof AppSettingsPeopleRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/slack': {
      id: '/_app/settings/slack'
      path: '/slack'
      fullPath: '/settings/slack'
      preLoaderRoute: typeof AppSettingsSlackRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsConnectionsRoute: typeof AppSettingsConnectionsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsPeopleRoute: typeof AppSettingsPeopleRoute
  AppSettingsSlackRoute: typeof AppSettingsSlackRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsConnectionsRoute: AppSettingsConnectionsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsPeopleRoute: AppSettingsPeopleRoute,
  AppSettingsSlackRoute: AppSettingsSlackRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMyTasksRoute: typeof AppMyTasksRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsProjectKeyRoute: typeof AppProjectsProjectKeyRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppInboxRoute: AppInboxRoute,
  AppMyTasksRoute: AppMyTasksRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppProjectsProjectKeyRoute: AppProjectsProjectKeyRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
